module.exports = __webpack_public_path__ + "img/grass-3.155aac19.png";